"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.NameAndColor = exports.DescriptionContainer = exports.ImgResponsive = exports.RemoveItem = exports.IconButton = exports.QuantitySize = exports.ReservationMsg = exports.Name = exports.Campaign = exports.UnitMSRP = exports.UnitAmount = exports.Title = exports.CampaignGroup = exports.ItemContentRow = exports.ItemContent = exports.ItemContainer = exports.HiddenScrollbarParent = void 0;
const hiddenscroll_1 = require("@kawaui/hiddenscroll");
const placeholder_1 = require("@kawaui/placeholder");
const styled_components_1 = __importStar(require("styled-components"));
const helpers_1 = require("./helpers");
const IMAGE_SIZE = '63px';
const IMAGE_SIZE_DESKTOP = '90px';
exports.HiddenScrollbarParent = (0, styled_components_1.default)(hiddenscroll_1.HiddenScroll) `
  display: flex;
  flex-direction: column;
  margin-bottom: ${({ theme }) => theme.space.s150};

  > div {
    box-sizing: border-box;
  }
`;
exports.ItemContainer = styled_components_1.default.div `
  position: relative;

  display: grid;
  grid-template-columns: ${IMAGE_SIZE} 1fr;

  ${({ noCursor }) => !noCursor && 'cursor: pointer'};

  &:not(:first-child) {
    margin-top: 1rem;
  }

  @media ${helpers_1.onDesktop} {
    grid-template-columns: ${IMAGE_SIZE_DESKTOP} 1fr;
  }
`;
exports.ItemContent = styled_components_1.default.div `
  display: flex;
  flex: 1;
  flex-direction: column;
  margin-left: ${({ theme }) => theme.space.s200};
`;
exports.ItemContentRow = styled_components_1.default.div `
  display: flex;
  align-items: center;
`;
exports.CampaignGroup = styled_components_1.default.div `
  width: 100%;

  &:first-child {
    margin-top: 0;
  }

  &:not(:first-child) {
    margin-top: 30px;
  }
`;
exports.Title = styled_components_1.default.div `
  margin-bottom: ${({ theme }) => theme.space.s200};

  color: ${({ theme }) => theme.colors.gray.s700};

  font-family: ${({ theme }) => theme.fontFamily.title};
  font-size: 1rem;
  font-weight: 500;
`;
exports.UnitAmount = styled_components_1.default.div `
  color: ${({ theme }) => theme.colors.main.base};

  font-size: 1.25rem;
  font-weight: 600;
`;
exports.UnitMSRP = styled_components_1.default.div `
  margin-right: ${({ theme }) => theme.space.s100};

  font-size: 1.25rem;
  font-weight: 500;
`;
exports.Campaign = styled_components_1.default.div `
  font-family: ${({ theme }) => theme.fontFamily.title};
`;
exports.Name = styled_components_1.default.div `
  color: ${({ theme }) => theme.colors.gray.s700};
  font-weight: 500;
`;
exports.ReservationMsg = styled_components_1.default.div `
  color: ${({ theme }) => theme.colors.gray.s800};
  font-weight: 500;
`;
exports.QuantitySize = styled_components_1.default.div `
  ${({ theme }) => (0, styled_components_1.css)(theme.typography.body.text)}

  color: ${({ theme }) => theme.colors.text.body};
`;
exports.IconButton = styled_components_1.default.span `
  position: absolute;

  cursor: pointer;

  > * {
    width: 19px;
    height: 19px;
  }
`;
exports.RemoveItem = styled_components_1.default.div `
  position: relative;

  width: 19px;
  height: 19px;
`;
exports.ImgResponsive = (0, styled_components_1.default)(placeholder_1.Img) `
  width: ${IMAGE_SIZE};
  height: ${IMAGE_SIZE};

  @media ${helpers_1.onDesktop} {
    width: ${IMAGE_SIZE_DESKTOP};
    height: ${IMAGE_SIZE_DESKTOP};
  }
`;
exports.DescriptionContainer = styled_components_1.default.div `
  display: flex;
`;
exports.NameAndColor = styled_components_1.default.div `
  margin-top: ${({ theme }) => theme.colors.gray.s050};

  color: ${({ theme }) => theme.colors.gray.s700};

  ${({ theme }) => (0, styled_components_1.css)(theme.typography.body.text)}
`;
